import API from "../../../utils/helpers/API.helpers";

const DeadlineService = {
  async getDeadlinesList(mkSpesialType, term) {
    const params = {};
    if (mkSpesialType) params["jenis_sidang"] = mkSpesialType;
    if (term) params["term"] = term;

    return await API.get({ 
      endpoint: "/deadline-submisi/",
      params: params
    });
  },
  async createDeadline(deadlineDetails) {
    return await API.post({
      endpoint: "/deadline-submisi/",
      data: deadlineDetails,
    });
  },
  async updateDeadline(id, deadlineDetails) {
    return await API.put({
      endpoint: `/deadline-submisi/${id}/`,
      data: deadlineDetails,
    });
  },
  async deleteDeadline(id) {
    return await API.delete({
      endpoint: `/deadline-submisi/${id}/`,
    });
  },
};

export default DeadlineService;
